<button
  mat-raised-button
  [disabled]="disabled"
  color="primary"
  [ngClass]="!disabled ? (gameTenantKind === 'Company' ? '' : 'btn school-bg') : ''"
  (click)="onClick.emit()"
>
  <ng-content></ng-content>
</button>
